import { Injectable } from '@angular/core';
import { AppState } from '@app/store';
import { select, Store } from '@ngrx/store';
import { setDailyAllowanceFormValues } from './actions/daily-allowance-patient.actions';
import { getDailyAllowanceRecommendation } from './actions/daily-allowance-recommendation.actions';
import { navigateBackToStep, setDailyAllowanceStep, startDailyAllowance } from './actions/daily-allowance-steps.actions';
import { DailyAllowanceStep } from '../daily-allowance-step';
import { PanelSectionTypeEnum } from '@app/shared/utils';
import { selectDailyAllowancePetSummary, selectStep, selectSteps } from './selectors/daily-allowance-steps.selectors';
import { Observable } from 'rxjs';
import { PetInfo } from '@app/core/models';

@Injectable()
export class DailyAllowanceFacade {
  public steps$: Observable<DailyAllowanceStep[]> = this.store$.pipe(select(selectSteps));
  public step$: Observable<DailyAllowanceStep> = this.store$.pipe(select(selectStep));
  public dailyAllowancePetSummary$: Observable<PetInfo> = this.store$.pipe(select(selectDailyAllowancePetSummary));

  constructor(private readonly store$: Store<AppState>) {}

  /** daily-allowance-patient.actions */
  setDailyAllowanceFormValues(): void {
    this.store$.dispatch(setDailyAllowanceFormValues());
  }

  /** daily-allowance-recommendation.actions */
  getDailyAllowanceRecommendation(): void {
    this.store$.dispatch(getDailyAllowanceRecommendation());
  }

  /** daily-allowance-steps.actions */
  startDailyAllowance(withIdentification: boolean, persist?: boolean, isNewPet?: boolean): void {
    this.store$.dispatch(startDailyAllowance({ withIdentification, persist, isNewPet }));
  }

  setDailyAllowanceStep(step: DailyAllowanceStep): void {
    this.store$.dispatch(setDailyAllowanceStep({ value: step }));
  }

  navigateBackToStep(value: PanelSectionTypeEnum): void {
    this.store$.dispatch(navigateBackToStep({ value }));
  }
}
